import { AnalyticsBrowser } from '@segment/analytics-next';
import { posthog } from 'posthog-js';
import type { AnalyticsActionType } from '@/app/shared/types/analytics';
import Logger from '@/app/shared/utils/logger';
import { analyticsReducer, initialAnalyticsState } from '../context/analyticsReducer';

const analytics = AnalyticsBrowser.load({ writeKey: import.meta.env.REACT_APP_SEGMENT_KEY as string });
const logger = new Logger('iLendingHubSegmentAnalytics');
let state = initialAnalyticsState;

export type NestedObject = {
  [key: string]: string | number | boolean | null | undefined | NestedObject | NestedObject[];
};

analytics.ready().then(() => {
  posthog.init(import.meta.env.REACT_APP_POSTHOG_KEY as string, {
    api_host: 'https://us.i.posthog.com',
    capture_pageview: false,
    loaded: () => {
      logger.log('PostHog loaded and connected to Segment');
    },
  });
});

const dispatch = (action: AnalyticsActionType) => {
  state = analyticsReducer(state, action);
};

const trackPage = (pageName: string) => {
  try {
    analytics.page(pageName);
    logger.log('Analytics trackPage ->', pageName);
  } catch (error) {
    logger.log('Analytics trackPage error ->', pageName, error);
  }
  dispatch({ type: 'TRACK_PAGE', payload: { eventType: pageName, parameters: {} } });
};

const trackClick = (eventType: string, parameters?: NestedObject) => {
  try {
    analytics.track(eventType, parameters);
    logger.log('Analytics trackClick ->', eventType, parameters ?? '');
  } catch (error) {
    logger.log('Analytics trackClick error ->', eventType, parameters, error);
  }
  dispatch({ type: 'TRACK_CLICK', payload: { eventType, parameters } });
};

const trackFormSubmit = (eventType: string, parameters?: NestedObject) => {
  try {
    analytics.track(eventType, parameters);
    logger.log('Analytics trackFormSubmit ->', eventType, parameters);
  } catch (error) {
    logger.log('Analytics trackFormSubmit error ->', eventType, parameters, error);
  }
  dispatch({
    type: 'TRACK_FORM_SUBMIT',
    payload: { eventType, parameters },
  });
};

const trackSystemError = (eventType: string, parameters?: NestedObject) => {
  try {
    analytics.track(eventType, parameters);
    logger.log('Analytics trackSystemError ->', eventType, parameters);
  } catch (error) {
    logger.log('Analytics trackSystemError error ->', eventType, parameters, error);
  }
  dispatch({
    type: 'TRACK_SYSTEM_ERROR',
    payload: { eventType, parameters },
  });
};

const identifyUser = (userId: string) => {
  try {
    analytics.identify(userId);
    logger.log('Analytics identifyUser ->', userId);
  } catch (error) {
    logger.log('Analytics identifyUser error ->', error);
  }
  dispatch({
    type: 'IDENTIFY_USER',
    payload: { eventType: 'identify_user', parameters: {userId } },
  });
};


export { trackPage, trackClick, trackFormSubmit, trackSystemError, identifyUser };
